import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { ThemeToggle } from '../../context/ThemeContext';

const Header = () => {
  const { user, login, logout, loading } = useAuth();
  const [showUserMenu, setShowUserMenu] = useState(false);

  return (
    <header className="header" data-testid="header">
      <div className="header-inner">
        <div className="logo-section">
          <Link to="/" className="logo" data-testid="logo">Framecast</Link>
          <span className="tagline">How the world frames the news</span>
        </div>
        <nav className="header-nav">
          <Link to="/stories" className="header-link">Stories</Link>
          <Link to="/digest" className="header-link">
            Digest {user?.tier !== 'pro' && <span className="pro-badge-small">Pro</span>}
          </Link>
          <Link to="/methodology" className="header-link">Methodology</Link>
          <Link to="/sources" className="header-link">Sources</Link>
          <Link to="/enterprise" className="header-link enterprise-link" data-testid="enterprise-link">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{marginRight: '4px', verticalAlign: 'middle'}}>
              <rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect>
              <path d="M9 22v-4h6v4"></path>
              <path d="M8 6h.01"></path>
              <path d="M16 6h.01"></path>
              <path d="M12 6h.01"></path>
              <path d="M12 10h.01"></path>
              <path d="M12 14h.01"></path>
              <path d="M16 10h.01"></path>
              <path d="M16 14h.01"></path>
              <path d="M8 10h.01"></path>
              <path d="M8 14h.01"></path>
            </svg>
            Enterprise
          </Link>
          <ThemeToggle />
          {!loading && (
            user ? (
              <div className="user-menu-container">
                <button 
                  className="user-avatar-btn" 
                  onClick={() => setShowUserMenu(!showUserMenu)}
                  data-testid="user-menu-btn"
                >
                  {user.picture ? (
                    <img src={user.picture} alt={user.name} className="user-avatar" />
                  ) : (
                    <div className="user-avatar-placeholder">
                      {user.name?.charAt(0) || user.email?.charAt(0) || 'U'}
                    </div>
                  )}
                </button>
                {showUserMenu && (
                  <div className="user-dropdown" data-testid="user-dropdown">
                    <div className="user-info">
                      <span className="user-name">{user.name}</span>
                      <span className="user-email">{user.email}</span>
                      <span className={`user-tier ${user.tier || 'free'}`}>
                        {user.tier === 'pro' ? 'Pro' : 'Free'}
                      </span>
                    </div>
                    <hr />
                    <Link to="/bookmarks" className="dropdown-item" onClick={() => setShowUserMenu(false)}>
                      🔖 Bookmarks
                    </Link>
                    <Link to="/digest" className="dropdown-item" onClick={() => setShowUserMenu(false)}>
                      Daily Digest {user.tier !== 'pro' && '🔒'}
                    </Link>
                    {user.tier !== 'pro' && (
                      <Link to="/subscribe" className="dropdown-item upgrade-link" onClick={() => setShowUserMenu(false)}>
                        Upgrade to Pro
                      </Link>
                    )}
                    <button className="dropdown-item logout-btn" onClick={logout} data-testid="logout-btn">
                      Sign Out
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <>
                <button className="header-link login-btn" onClick={login} data-testid="login-btn">
                  Sign In
                </button>
                <Link to="/subscribe" className="header-cta" data-testid="subscribe-btn">
                  Subscribe
                </Link>
              </>
            )
          )}
        </nav>
      </div>
    </header>
  );
};

export default Header;
